/**
 * Auth action links (password reset) carry a continue URL that Firebase checks
 * against the project's authorized domains. Those list the admin sites'
 * custom domains but not their default *.web.app / *.firebaseapp.com aliases,
 * so a link built from the page's own origin fails on an alias
 * (auth/unauthorized-continue-uri, 08/09/2026). Both admin sites deploy the
 * same production-mode bundle, so the hostname — not the build flavor — is
 * what tells them apart.
 */
const CANONICAL_HOST: Record<string, string> = {
  "admin.pinstaq.com": "admin.pinstaq.com",
  "pinstaq-admin.web.app": "admin.pinstaq.com",
  "pinstaq-admin.firebaseapp.com": "admin.pinstaq.com",
  "admin-staging.pinstaq.com": "admin-staging.pinstaq.com",
  "pinstaq-admin-staging.web.app": "admin-staging.pinstaq.com",
  "pinstaq-admin-staging.firebaseapp.com": "admin-staging.pinstaq.com",
};

export function canonicalOrigin(location: { hostname: string; origin: string }): string {
  const host = CANONICAL_HOST[location.hostname];
  return host ? `https://${host}` : location.origin;
}
